import { render, staticRenderFns } from "./serverDetailsModal.vue?vue&type=template&id=ba4ae564&"
import script from "./serverDetailsModal.vue?vue&type=script&lang=js&"
export * from "./serverDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports